import { useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import { memo } from 'react';

import {
  QontoConnector,
  StepLabelStyled,
  StepperLabelContainerStyled,
  StepperStyle,
  StepperUnderlineContainerStyled,
  StepStyled,
} from './TrlStepper.styles';

export const TrlStepper = memo(({ activeStep, steps, completed, isModal }) => {
  const currentTheme = useTheme();

  const completedColor = {
    true: currentTheme.palette.colors.label,
  };

  return (
    <StepperStyle
      nonLinear
      activeStep={activeStep}
      connector={<QontoConnector />}
      isModal={isModal}
    >
      {steps.map((label, index) => (
        <StepStyled
          key={label}
          completed={completed[index]}
          index={index}
          nSteps={steps.length}
          isModal={isModal}
        >
          <StepLabelStyled completed={completed} isModal={isModal}>
            <StepperLabelContainerStyled>{label}</StepperLabelContainerStyled>
            <StepperUnderlineContainerStyled
              activeStep={activeStep}
              index={index}
              completedColor={completedColor}
              completed={completed}
            />
          </StepLabelStyled>
        </StepStyled>
      ))}
    </StepperStyle>
  );
});

TrlStepper.displayName = 'TrlStepper';

TrlStepper.propTypes = {
  activeStep: PropTypes.number.isRequired,
  steps: PropTypes.array.isRequired,
  completed: PropTypes.object.isRequired,
  isModal: PropTypes.bool,
};
